<template>
  <el-table-column
    prop="stock_tool.name"
    sortable="custom"
    label="Készletek köre"
    show-overflow-tooltip
    min-width="180"
  >
    <template slot-scope="scope">
      <span v-if="scope.row.stock_tool">{{ scope.row.stock_tool.name }}</span>
      <span v-else>-</span>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'stock_tool.name',
  };
</script>
